import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    searchBox: {
      "& .MuiFormControl-root": {
        height: "36px"
      },
      margin: 0,
      width: "100%"
    },
    requiredMark: {
      color: theme.palette.error.light
    },
    radioGroup: {
      flexDirection: "row"
    },
    divider: {
      padding: "0 2.4rem"
    },
    bottomBar: {
      padding: "2.4rem 2.4rem 2.4rem 0",
      display: "flex",
      justifyContent: "space-between"
    },
    colorInfo: {
      color: theme.palette.grey[700]
    },
    colorSuccess: {
      color: theme.palette.success.main
    },
    colorError: {
      color: theme.palette.error.light
    },
    info: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center"
    },
    icon: {
      marginRight: "1.1rem"
    },
    actionButton: {
      width: "132px",
      fontSize: "1.4rem",
      height: "40px"
    },
    flex: {
      display: "flex"
    },
    disableBtn: {
      "& svg path": {
        stroke: "#CCCCCC"
      }
    },
    textError: {
      color: theme.palette.error.light
    }
  }),
  { name: "StockOnHandFilter" }
);

export default useStyles;
